module.exports = __webpack_public_path__ + "static/portfolio-about-427026702aee4ecdc0d74b8b849c9840.jpg";